<div class="row">
  <div class="col-12">
    <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy table-sm">
  <thead>
    <tr>
      <th class="text-center" colspan="3">Medição / Empenho</th>
      <th class="text-center" colspan="4">Documento Fiscal</th>
      <th></th>
    </tr>
    <tr>
      <th scope="col" style="width: 100px">Medição</th>
      <th scope="col" style="width: 100px">Empenho</th>
      <th scope="col" style="width: 100px">Data</th>
      <th scope="col" style="width: 100px">Documento Fiscal</th>
      <th scope="col" style="width: 100px">Estado</th>
      <th scope="col" style="width: 100px">Valor</th>
      <th scope="col" style="width: 100px">Data</th>
      <th scope="col" style="width: 100px"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of entidade?.DocFiscal">
      <td>
        <span *ngIf="!item.editavel">{{item.MedicaoNumero}}</span>
        <select *ngIf="item.editavel" class="form-control" [(ngModel)]="item.MedicaoNumero"
          [ngModelOptions]="{standalone: true}" (change)="carregarLiquidacoes(item.MedicaoNumero)">
          <option *ngFor="let item of listaExecucao" [ngValue]="item.ConferenciaMedicaoSim.NumeroMedicao">
            {{item.ConferenciaMedicaoSim.NumeroMedicao}}
          </option>
        </select>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.NotaEmpenhoNumero}}</span>
        <select *ngIf="item.editavel" class="form-control" [(ngModel)]="item.liquidacaoId"
          [ngModelOptions]="{standalone: true}" (change)="atribuirLiquidacao()">
          <option *ngFor="let item of listaLiquidacao" [ngValue]="item.liquidacaoId">
            {{item.NotaEmpenhoNumero}}
          </option>
        </select>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.NotaEmpenhoDataEmissao}}</span>
        <p-calendar (onFocus)="onFocusDate()" *ngIf="item.editavel" [(ngModel)]="item.NotaEmpenhoDataEmissao"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string" dateFormat="dd/mm/yy"
          [showOnFocus]="true">
        </p-calendar>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.DocumentoFiscalNumero}}</span>
        <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="item.DocumentoFiscalNumero"
          [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.DocumentoFiscalUF}}</span>
        <select *ngIf="item.editavel" class="form-control" [(ngModel)]="item.DocumentoFiscalUF"
          [ngModelOptions]="{standalone: true}">
          <option *ngFor="let item of opcoesUF" [ngValue]="item.id">{{item.nome}}</option>
        </select>
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.DocumentoFiscalValor | number: '1.2-2'}}</span>
        <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="item.DocumentoFiscalValor"
          [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
      </td>

      <td>
        <span *ngIf="!item.editavel">{{item.DocumentoFiscalDataEmissao}}</span>
        <p-calendar (onFocus)="onFocusDate()" *ngIf="item.editavel" [(ngModel)]="item.DocumentoFiscalDataEmissao"
          [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string" dateFormat="dd/mm/yy"
          [showOnFocus]="true">
        </p-calendar>
      </td>

      <td class="text-right">
        <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>